﻿import { Component, Input, Output,OnInit, OnDestroy ,EventEmitter} from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';



@Component({
    selector: 'language-choosen',
    templateUrl: './language-localisation.component.html',
})
export class LanguageLocalisationComponent implements OnInit {
  
    private _localText: string;
    @Input() 
    public get localText(): string { return this._localText; };
    public set localText(x: string) {
        this._localText = x;

        }
  
    constructor(private sanitizer: DomSanitizer) {
       
    }

    ngOnInit() {
       
    }

    ngOnDestroy() { }

    public setLocales = () => {
       
     this.localText = this._localText;
      

    }
}